import React from "react";
import { object, string } from "prop-types";
import { Link, WithLazy } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";

import Headline from "../../atoms/Headline";
import PublishedAt from "../../atoms/PublishedAt";

import { staticTexts } from "../../utils/Translate";
import { googleTagEvents } from "../../utils/utils";

import "./customStoryCard10.m.css";

const CustomStoryCard10 = ({ story, className = "", publisherAttributes, storyType }) => {
  const subHeadlineStyle = `${publisherAttributes.lang}-sub-headline`;
  const sentTime = story.created_time + " GMT";

  const showLink = story.notification_url !== "https://www.prothomalo.com";

  return (
    <div styleName={`base ${publisherAttributes.lang === "en" ? "en-base" : ""}`} className={className}>
      <div styleName="wrapper" className={`${showLink ? "" : "no-link"}`}>
        <div styleName="story-data">
          <PublishedAt
            date={new Date(sentTime.toLocaleString())}
            className={`notification-storydate ${showLink ? "" : "time-style"}`}
          />
          {showLink ? (
            <Link href={story.notification_url}>
              <span
                onClick={
                  storyType === "notifications"
                    ? () => googleTagEvents("push-notification-click", story.notification_title, "")
                    : ""
                }
              >
                <Headline
                  text={story.notification_title}
                  headerLevel={2}
                  headlineType={27}
                  className="headline title-headline"
                />
                <Headline
                  text={staticTexts(publisherAttributes.lang).detailsText}
                  headerLevel={4}
                  className="headline-details"
                />
              </span>
            </Link>
          ) : (
            <Headline text={story.notification_title} headerLevel={2} headlineType={27} className="headline" />
          )}

          {story.notification_message ? (
            <Headline
              text={story.notification_message}
              headerLevel={4}
              headlineType={6}
              className="sub-headline"
              styleName={subHeadlineStyle}
            />
          ) : null}
        </div>
        {showLink && story.notification_image && (
          <WithLazy margin="50px">
            {() => (
              <Link href={story.notification_url}>
                <img
                  src={story.notification_image}
                  onClick={
                    storyType === "notifications"
                      ? () => googleTagEvents("push-notification-click", story.notification_title, "")
                      : ""
                  }
                />
              </Link>
            )}
          </WithLazy>
        )}
      </div>
    </div>
  );
};

CustomStoryCard10.propTypes = {
  story: object.isRequired,
  className: string,
  publisherAttributes: object,
  storyType: string,
};

const mapStateToProps = (state) => ({
  isLoading: get(state, ["pageLoading"], false),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, null)(CustomStoryCard10);
